<template lang="pug">
.gallery
    MultiLoad(
        @uploaded="uploaded"
    )

    .gallery__photoes(
        v-if="images.length"
    )
        PhotoBlock(
            v-for="(photo, index) in images"
            :key="photo.id || photo.original_image"
            :value="images[index]"
            @input="obj => change(obj, index)"
            @remove="remove(index)"
        )
</template>

<script>
import MultiLoad from '@/components/forms/subforms/MultiLoad.vue';
import PhotoBlock from '@/components/forms/subforms/PhotoBlock.vue';
import { mapGetters, mapMutations } from 'vuex';

export default {
  name: 'Gallery',

  components: {
    MultiLoad,
    PhotoBlock,
  },

  updated() {
  },

  computed: {
    ...mapGetters({
        current: 'residential/getCurrent',
    }),

    images: {
      get() {
        return this.current.images;
      },

      set(images) {
        this.setValue({ images });
      },
    },
  },

  methods: {
    ...mapMutations({
      setValue: 'residential/setValue',
    }),

    uploaded(files) {
      files.forEach((original_image) => {
        this.images.push({
          original_image,
          alt: '',
          title: '',
        });
      });
    },

    change(obj, index) {
      this.images.splice(index, 1, obj);
    },

    remove(index) {
      this.images.splice(index, 1);
    },
  },
};
</script>

<style lang="scss" scoped>
.gallery {
    &__photoes {
        margin-top: 25px;
        display: grid;
        grid-template-columns: repeat(3, 310px);
        grid-gap: 40px;
    }
}
</style>
